export const calcSize = (size) => {
    let fileSize = parseFloat(size);
    // fileSize为浮点数 用 < 0.000001 替代 === 0
    if (isNaN(fileSize) || fileSize < 0.0000001) {
        return '0';
    }
    const SIZE_SUFFIX = ['B', 'K', 'M', 'G', 'T', 'P'];
    let suffixIndex = 0;
    // 在Mac上实验发现 取1024造成显示的大小和实际大小不一致
    // 因为单位制不同 见 https://superuser.com/questions/938234/size-of-files-in-windows-os-its-kb-or-kb
    const BIT_NUMBER_SYSTEM = 1024;
    while (fileSize >= BIT_NUMBER_SYSTEM && suffixIndex < SIZE_SUFFIX.length) {
        suffixIndex++;
        fileSize /= BIT_NUMBER_SYSTEM;
    }
    const suffix = SIZE_SUFFIX[suffixIndex];
    fileSize = Number(fileSize.toFixed(2));
    if (!fileSize)
        return undefined;
    return `${fileSize}${suffix}`;
};
export const getFileType = (file) => {
    return file.name?.split('.').pop()?.toLowerCase();
};
/** 是否可以使用图片预览组件 */
export const canUseImageViewer = (file) => {
    const fileType = getFileType(file);
    return (fileType &&
        (file.objectUrl || file.url) &&
        ['png', 'jpg', 'jpeg', 'gif', 'svg'].includes(fileType));
};
